// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n/i18n";
import App from "./App";
import "./index.css"; // Make sure this imports Tailwind

const root = ReactDOM.createRoot(document.getElementById("root"));

// Dev-only visual harness for the finance design (open /#__fin_preview while
// `npm start` is running). Stripped from production bundles by the env guard.
if (
  process.env.NODE_ENV === "development" &&
  window.location.hash === "#__fin_preview"
) {
  const FinPreview = require("./dev/FinPreview").default;
  root.render(<FinPreview />);
} else {
  root.render(<App />);
}
